module.exports = __webpack_public_path__ + "h5/img/bq.c91326d8.png";